import { proxy } from 'valtio';
import { isEmpty } from 'lodash';

import api from '@/api';
import storeRematch from '@/store';

import createCache from '@/restore/oil-production-loss/cache';

const ABORT_ERROR_CODE = 20;

const defaultState = {
    data: null,
    activeVersion: null,
    isLoading: false,
};

export const store = proxy({
    ...defaultState,
});

const createActions = () => {
    let kyController = new AbortController();
    const cache = createCache();

    return {
        setActiveVersion(version) {
            store.activeVersion = version;
        },

        resetDefaultState() {
            kyController.abort();
            kyController = new AbortController();

            Object.entries(defaultState).map(([key, value]) => {
                store[key] = value;
            });
        },

        getParams() {
            return {
                versionId: store.activeVersion,
            };
        },

        async fetch() {
            const {
                tree: { calculationObject },
            } = storeRematch.getState();

            if (isEmpty(calculationObject)) return;

            store.isLoading = true;

            const { id, node } = calculationObject;
            const payload = { body: {}, signal: kyController.signal };

            if (node === 'field') {
                payload.body.fieldId = id;
            } else if (node === 'company') {
                payload.body.ventureId = id;
            }

            try {
                const versions = await cache.get(payload, api.oilProductionLoss.fetchVersions);

                if (!versions) return;

                store.data = normalizeVersionToList(versions);
                store.activeVersion = getVersionVersionWithZeroId(versions);

                store.isLoading = false;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('::version fetch error', error);
                if (error.code !== ABORT_ERROR_CODE) store.isLoading = false;
            }
        },
    };
};

function normalizeVersionToList(versions) {
    return versions.map(version => {
        return { label: version.title, value: version.id };
    });
}

function getVersionVersionWithZeroId(versions) {
    if (!isEmpty(versions)) {
        return versions.some(({ id }) => id === 0) ? 0 : versions[0].id;
    }

    return null;
}

export const actions = createActions();
